import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingEventName, UploadPhotoTakePhotoOptionSelectedTrackingEvent } from "./tracking";

interface TrackUploadPhotoTakePhotoOptionSelectedFunction {
  (): void;
}

interface UseTrackUploadPhotoTakePhotoOptionSelectedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string;
  readonly tradename: Tradename;
}

interface UseTrackUploadPhotoTakePhotoOptionSelectedFunction {
  (agrs: UseTrackUploadPhotoTakePhotoOptionSelectedFunctionArgs): TrackUploadPhotoTakePhotoOptionSelectedFunction;
}

const useTrackUploadPhotoTakePhotoOptionSelected: UseTrackUploadPhotoTakePhotoOptionSelectedFunction = ({
  country,
  segment,
  customerId,
  tradename,
}) => {
  const emitUserEvent = useEmitUserEvent<UploadPhotoTakePhotoOptionSelectedTrackingEvent>();

  const trackUploadPhotoTakePhotoOptionSelected: TrackUploadPhotoTakePhotoOptionSelectedFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.UPLOAD_PHOTO_TAKE_PHOTO_OPTION_SELECTED,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_photos`,
      store: country,
      segment,
      userId: customerId,
      tradename,
    });
  }, [country, emitUserEvent, customerId, tradename, segment]);

  return trackUploadPhotoTakePhotoOptionSelected;
};

export { useTrackUploadPhotoTakePhotoOptionSelected };
